import { render, staticRenderFns } from "./Summary.PromotionCredit.vue?vue&type=template&id=2280ef12&scoped=true"
import script from "./Summary.PromotionCredit.vue?vue&type=script&lang=js"
export * from "./Summary.PromotionCredit.vue?vue&type=script&lang=js"
import style0 from "./Summary.PromotionCredit.vue?vue&type=style&index=0&id=2280ef12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280ef12",
  null
  
)

export default component.exports